import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonOlList from '../../../common-components/common-ol-list';

const CommonOlListObj = {
    colorNumber: '#7927E0',
    list: [
        'Посещение коворкинга',
        'Аренда залов в&nbsp;конгресс-центре',
        'Бизнес экскурсии (однодневные/групповые/многодневные)',
        'Экскурсии для иностранцев (однодневные/групповые/многодневные)',
        'Аренда офисов',
        'Приглашение стартапов на&nbsp;питч',
        'Вступление инвесторов в&nbsp;сообщество AdVentureLand',
        'Набор участников на&nbsp;10&nbsp;мероприятий в&nbsp;Лектории',
        'Набор волонтеров на&nbsp;Startup Village',
        'Набор волонтеров на&nbsp;Остров 10&ndash;22',
        'Набор волонтеров на&nbsp;Открытые Инновации',
        'Увеличение посетителей в&nbsp;Food Market Сколково',
    ],
};

const Task = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper caseName="skolkovo-task" smallPaddings={true} isMargin={false}>
                <CommonTitle>Задача</CommonTitle>
                <div className="skolkovo-task__container">
                    <CommonUsualText className="skolkovo-task__text">
                        За&nbsp;8&nbsp;месяцев разработать и&nbsp;протестировать гипотезы
                        для&nbsp;каждого направления и&nbsp;закрыть минимум 100% KPI
                        по&nbsp;количеству лидов для 12 направлений Технопарка:
                    </CommonUsualText>
                    <CommonOlList CommonOlList={CommonOlListObj} />
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Task;
